import { useTranslation } from "react-i18next";
import { Plus, Search, X } from "lucide-react";
import { NeuButton } from "../neu/Neu";

// صف الأدوات: بحث عريض + زر أساسي واحد للإنشاء.
export const Toolbar = ({ search, onSearch, placeholder, actionLabel, onAction,
                          testid = "toolbar" }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={testid}>
      {onAction ? (
        <NeuButton variant="primary" className="flex items-center gap-2 px-4 py-3 text-xs"
                   data-testid={`${testid}-action`} onClick={onAction}>
          <Plus className="h-4 w-4" /> {actionLabel}
        </NeuButton>
      ) : null}
      <div className="flex min-w-[220px] flex-1 items-center gap-2 rounded-2xl bg-background px-4 py-3 shadow-neu-sm">
        <Search className="h-4 w-4 shrink-0 text-muted-foreground" />
        <input
          data-testid={`${testid}-search`}
          className="min-w-0 flex-1 bg-transparent text-sm font-bold outline-none"
          placeholder={placeholder || t("purchases.searchAnything")}
          value={search}
          onChange={(e) => onSearch(e.target.value)}
        />
        {search ? (
          <button type="button" data-testid={`${testid}-clear`} onClick={() => onSearch("")}>
            <X className="h-4 w-4 text-destructive" />
          </button>
        ) : null}
      </div>
    </div>
  );
};
